/**
 * Booking sources that count as DesignMyNight-owned journeys.
 *
 * Mirrors `Booking::isDMNBooking()` (dmn/classes/Booking.php), which treats
 * `SOURCE_DMN` ("designmynight"), `SOURCE_DMN_ADMIN` and `SOURCE_DMN_MOBILE`
 * as DesignMyNight traffic. Collins' own `Venue::getBookingRules()` compares
 * against `Booking::SOURCE_DMN` — the string is "designmynight", never "dmn".
 *
 * This must stay an allow-list: checking `source !== "partner"` would wrongly
 * apply DesignMyNight-only rules to sources such as `admin` or `tonic`.
 */
export const DMN_BOOKING_SOURCES: readonly string[] = ["designmynight", "designmynight-admin", "designmynight-mobile"];

/**
 * Whether a booking source is a DesignMyNight journey, and therefore subject to
 * a booking type's `booking_rules_dmn` overrides.
 */
export function isDmnSource(source?: string | null): boolean {
  return !!source && DMN_BOOKING_SOURCES.includes(source);
}

/**
 * Booking sources that get the DesignMyNight-branded header on /book.
 *
 * The maroon banner is DesignMyNight's own chrome, so it only appears on
 * DMN-sourced journeys; partner and venue-embedded bookings render the form
 * unbranded. `dmn` is kept alongside `designmynight` as a shorthand callers
 * may send — unlike {@link DMN_BOOKING_SOURCES}, this is a branding decision,
 * not a mirror of Collins' `Booking::isDMNBooking()`.
 */
export const DMN_HEADER_SOURCES: readonly string[] = ["designmynight", "dmn"];

/**
 * Whether the booking source gets the DesignMyNight-branded header on /book.
 */
export function isDmnHeaderSource(source?: string | null): boolean {
  return !!source && DMN_HEADER_SOURCES.includes(source);
}
